import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface ICheckMarkIconProps extends IconPropsType {}

const CheckMarkIcon = ({
  size = 24,
  fill = '#fffff',
  ...props
}: ICheckMarkIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2372 5.52814L11.8654 17.2487L9.5841 17.4375L4.02344 11.8769L6.14476 9.75556L10.4534 14.0642L17.796 3.78442L20.2372 5.52814Z"
      fill={fill}
    />
  </svg>
);

export default CheckMarkIcon;
